import { AppSteps } from '../AppSteps/AppSteps';
import { Contact } from '../Contact/Contact';
import { ContentContainer } from '../ContentContainer/ContentContainer';
import { Divider } from '../Divider/Divider';
import styles from './ContactSection.module.scss';

export const ContactSection = () => {
  return (
    <section className={styles.base} id="contact">
      <ContentContainer>
        <AppSteps />
        <Divider className={styles.divider} />
        <Contact />
      </ContentContainer>
    </section>
  );
};
